// Libraries
var React = require('react');

// Styles
require('./TwitterEmbed.scss');

class TwitterEmbed extends React.Component {
	createTime(timestamp) {
		let date = new Date(timestamp);
		let hours = date.getHours();
		let minutes = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
		return hours + ":" + minutes;
	}

	componentDidMount() {
		if(window.twttr) window.twttr.widgets.load();
	}

	render() {
		return (
			<div className="TwitterEmbed">
				<div className="TwitterEmbed__wrapper">
					<div className="TwitterEmbed__body">
						<blockquote className="twitter-tweet">
							<a href={"https://twitter.com/" + this.props.data.AccountName + "/status/" + this.props.data.EntityId}>...</a>
						</blockquote>
					</div>
				</div>
			</div>
		)
	}
}

module.exports = TwitterEmbed;



// WEBPACK FOOTER //
// ./src/components/MDC/SocialTab/TwitterEmbed.js